import { DoubleMaterialityESRSAreaEnum } from "@green0meter/api-client";

import type { QuestionItemType } from "@api";

export const createFilterBySelections =
  (
    selectedIro: Set<string>,
    selectedStakeholderTypes: Set<string>,
    selectedEsrs: Set<string>,
    assessmentTopicMap: Map<
      string,
      DoubleMaterialityESRSAreaEnum | null | undefined
    >,
  ) =>
  (list: QuestionItemType[]): QuestionItemType[] => {
    const isAnySelected =
      selectedIro.size > 0 ||
      selectedStakeholderTypes.size > 0 ||
      selectedEsrs.size > 0;

    if (!isAnySelected) return [];

    return list.filter((q) => {
      if (selectedIro.size > 0) {
        const questionIroValues = (Array.isArray(q.iro) ? q.iro : [q.iro]).filter(
          (value): value is string | number => value !== null && value !== undefined,
        );
        const hasMatchingIro = questionIroValues.some((value) =>
          selectedIro.has(String(value)),
        );

        if (!hasMatchingIro) return false;
      }
      if (
        selectedStakeholderTypes.size > 0 &&
        !selectedStakeholderTypes.has(String(q.stakeholderType))
      ) {
        return false;
      }

      if (selectedEsrs.size > 0) {
        const topic = assessmentTopicMap.get(q.assessmentId);
        const hasMatchingTopic = topic !== null && topic !== undefined
          ? selectedEsrs.has(String(topic))
          : false;

        if (!hasMatchingTopic) return false;
      }

      return true;
    });
  };
